import {
  ClearButtonBehaviour,
  ConfirmationBox,
  Labeled,
  Select,
} from '@infotech-soe/erp-ui-kit';
import { tg } from '@infotech-soe/metaschema';
import React, { memo, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { useStyles as useDialogStyles } from '../dialogs/styles';

import { messages } from './messages';
import type { PivotSelectPresetFormProps } from './types';

const PivotSelectPresetForm = ({
  currentPreset,
  open,
  presetNames,
  onCancel,
  onConfirm,
}: PivotSelectPresetFormProps): React.JSX.Element => {
  const [name, setName] = useState(currentPreset ?? null);
  const dialogClasses = useDialogStyles();
  const { formatMessage } = useIntl();

  const options = useMemo(
    () =>
      presetNames.map(n => ({
        label: formatMessage(messages.preset, { name: n }),
        type: 'option',
        value: n,
      })),
    [formatMessage, presetNames]
  );

  return (
    <ConfirmationBox
      className={dialogClasses.dialog}
      open={open}
      height="auto"
      width={360}
      submitForbidden={!tg.isNotBlankString(name)}
      title={formatMessage(messages.openPreset)}
      onCancel={onCancel}
      onClose={onCancel}
      onConfirm={() => onConfirm?.(name ?? undefined)}
    >
      <Labeled label={formatMessage(messages.label)} required>
        <Select
          value={name}
          options={options}
          withClearButton={ClearButtonBehaviour.NONE}
          onChange={setName}
          onSubmit={v => tg.isNotBlankString(v) && onConfirm?.(v)}
        />
      </Labeled>
    </ConfirmationBox>
  );
};

export default memo(PivotSelectPresetForm);
